import { SET_SELECTION } from "redux/types";

export const setSelection = (selection) => ({
    payload: { selection },
    type: SET_SELECTION,
});
